import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { ProductService } from "../../services/product.service";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { Catalog, Product } from "../../models/product.model";
import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { StbCustomRenderNumberComponent } from "../smart-table-customs/custom-render-number";

import Shop from "../../models/shop.model";
import { DialogPrintProductsComponent } from "../dialog-print-products/dialog-print-products.component";
import { environment } from "../../../environments/environment";
import { PaginationProduct, ProductSpecParams } from "../../models/pagination";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { DialogProductOfflineComponent } from "../dialog-product-offline/dialog-product-offline.component";

@Component({
  selector: "ngx-view-pagination-products-offline",
  styleUrls: ["./view-pagination-products-offline.component.scss"],
  templateUrl: "./view-pagination-products-offline.component.html",
})
export class ViewPaginationProductsComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() mode?: string = "categories"; //categories/receipt/purchase
  @Input() products?: Product[] = [];
  @Output() onSelectedProduct: EventEmitter<any> = new EventEmitter();

  @Input() shop?: Shop;
  @Input() units?: Catalog[] = [];
  @Input() groups?: Catalog[] = [];
  @Input() categories?: Catalog[] = [];
  @Input() suppliers?: Catalog[] = [];
  @Input() producers?: Catalog[] = [];
  @Input() origins?: Catalog[] = [];
  @Input() sizes?: Catalog[] = [];
  @Input() colors?: Catalog[] = [];

  @ViewChild("title") title: ElementRef;
  @ViewChild("price") price: ElementRef;

  product: Product = new Product();

  loading = false;
  submitted = false;
  isEditing = false;

  uid = "anonymous";
  user: User;

  syncLive: boolean = environment.syncLive;
  timestamp: number = 0;
  //pagination
  paginationProduct: PaginationProduct = new PaginationProduct();
  specParams = new ProductSpecParams();
  @ViewChild("strSearch") strSearch: ElementRef;

  constructor(
    private userService: UserService,
    private productService: ProductService,
    private router: Router,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.specParams.isActive = true;
    const lastMonth = new Date();
    lastMonth.setDate(lastMonth.getDate() + -30);
    this.timestamp = lastMonth.getTime();

    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.user = user;
          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }

          if (this.syncLive) {
            this.getPaginationProduct();
          }
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.strSearch.nativeElement.focus();
    }, 1000);
  }

  //Quick create product
  initNewProduct() {
    let newProd = new Product();
    newProd.shopId = this.shopId;
    newProd.title = "";
    newProd.unitId = this.product.unitId;
    newProd.unitName = this.product.unitName;
    newProd.groupId = this.product.groupId;
    newProd.groupName = this.product.groupName;
    newProd.categoryId = this.product.categoryId;
    newProd.categoryName = this.product.categoryName;

    this.product = newProd;
  }

  printProducts() {
    this.dialogService
      .open(DialogPrintProductsComponent, {
        context: {
          shopId: this.shopId,
          uid: this.uid,
          products: this.products,
          shop: this.shop,
          showSelection: true,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((item) => {});
  }

  onNew() {
    this.initNewProduct();

    this.dialogService
      .open(DialogProductOfflineComponent, {
        context: {
          header: "Tạo mặt hàng",
          user: this.user,
          mode: "new",
          product: this.product,
          units: this.units,
          groups: this.groups,
          categories: this.categories,
          suppliers: this.suppliers,
          producers: this.producers,
          origins: this.origins,
          sizes: this.sizes,
          colors: this.colors,
          products: this.products,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.initNewProduct();
          this.specParams.pageIndex = 1;
          this.getPaginationProduct();
        }
      });
  }

  syncProduct() {
    this.loading = true;
    const subscription = this.productService
      .getProductsSync(this.shopId, this.timestamp)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            fsId: c.payload.doc.id,
            ...c.payload.doc.data(),
            createdOn: convertTimestamp(c.payload.doc.data().createdOn),
            updatedOn: convertTimestamp(c.payload.doc.data().updatedOn),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        console.log("syncProduct/getProductsSync:", data);
        _.forEach(data, (item) => {
          //sync data to offline DB
          this.productService.sync(item);
        });

        if (data.length > 0) {
          this.timestamp = data[data.length - 1].timestamp;
          console.log("syncProduct/timestamp:", this.timestamp);
        }

        this.loading = false;

        subscription.unsubscribe();
      });
  }

  //crud pagination
  edit(item: Product): void {
    let lecBk = _.clone(item);
    console.log("edit/DialogProductOfflineComponent/edit:", lecBk);

    this.dialogService
      .open(DialogProductOfflineComponent, {
        context: {
          header: "Cập nhật sản phẩm",
          user: this.user,
          mode: "edit",
          product: lecBk,
          units: this.units,
          groups: this.groups,
          categories: this.categories,
          suppliers: this.suppliers,
          producers: this.producers,
          origins: this.origins,
          sizes: this.sizes,
          colors: this.colors,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        console.log("DialogProductOfflineComponent/edit:", value);
        if (value) {
          item = value;
          this.product = value;

          const index = _.findIndex(this.paginationProduct.data, {
            id: value.id,
          });
          if (index > -1) {
            this.paginationProduct.data[index] = value;
          }
        }
      });
  }

  delete(item: Product): void {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loading = true;
          this.submitted = true;

          this.productService.deleteOffline(item).subscribe(
            (result) => {
              this.loading = false;
              this.submitted = false;
              const index = this.paginationProduct.data.indexOf(item);
              if (index > -1) this.paginationProduct.data.splice(index, 1);
            },
            (err) => {
              this.loading = false;
              this.submitted = false;
              console.log(err);
            }
          );
        }
      });
  }

  selected(item: Product): void {
    item.id = item.fsId ? item.fsId : item.id;
    this.onSelectedProduct.emit(item);
  }

  search() {
    this.specParams.search = this.specParams.search
      ? this.specParams.search.trim()
      : "";

    this.specParams.pageIndex = 1;
    this.getPaginationProduct();
  }

  pageChanged(index) {
    this.specParams.pageIndex = index;
    this.getPaginationProduct();
  }
  pagePrevious() {
    this.specParams.pageIndex--;
    this.getPaginationProduct();
  }
  pageNext() {
    this.specParams.pageIndex++;
    this.getPaginationProduct();
  }

  private getPaginationProduct() {
    console.log("getPaginationProduct/specParams:", this.specParams);

    this.loading = true;
    this.submitted = true;
    this.productService.getPaginationProduct(this.specParams).subscribe(
      (response) => {
        this.paginationProduct = response;

        this.loading = false;
        this.submitted = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
        this.submitted = false;
      }
    );
  }
  //end crud pagination
}
